export default __webpack_public_path__ + "static/media/cover.9a2c6418.jpg";